module.exports = __webpack_public_path__ + "static/media/sdg_icon_16.81faefc3.png";